import GroupContentNavbar from "./GroupContentNavbar";
import RequestContentNavbar from "./RequestContentNavbar";

export const ContentNavbar = ({
  isGroup,
  onHistoryPage,
}: {
  isGroup: boolean;
  onHistoryPage: boolean;
}) => {
  if (!isGroup && !onHistoryPage) {
    return null;
  }

  if (isGroup) {
    return <GroupContentNavbar onHistoryPage={onHistoryPage} />;
  }

  return <RequestContentNavbar onHistoryPage={onHistoryPage} />;
};
